import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-container" }
const _hoisted_2 = { class: "filter-container" }
const _hoisted_3 = { class: "action-list" }

import Pagination from '@/components/Pagination.vue'
import { useStore } from '@/store/index'
import { getCurrentInstance, reactive, ref } from 'vue'
import Keys from '@/constant/key'
import { joinParams } from '@/utils'
    
export default /*@__PURE__*/_defineComponent({
  __name: 'GiftExhibition',
  setup(__props) {

const { proxy } = getCurrentInstance() as any
    const store = useStore()
    const filters = reactive({
            name:               '',     //姓名
            user_phone:         '',     // 手机号
            start_date: '', // 开始时间
            end_date:   '', //  结束时间
            page:        1,      // 当前页码
            page_size:          10,     // 每页显示条数
            type:1,
            ilk:''
    })
    //礼品展申请列表
    const tableData = ref([])
    const total = ref(0)
    // 获取列表数据
    const getList = () => {
            proxy.$http.get('/admin/shops/get_shop_cooperate_list', filters).then(res => {
                const { code, data, msg } = res
                if (code != 200) { return proxy.$message({ type: 'error', message: msg }) }
                tableData.value = data.data
                total.value = data.total
            })
    }
    // 导出
    const output = () => {
            window.open(`${Keys.baseUrl}/admin/shops/export_shop_cooperate?${joinParams({...filters,user_id:store.state.user.userInfo.id})}`)
    }
    const search = () => {
        filters.page = 1
        getList()
    }
    const onPageChange = (val) => {
        filters.page = val
        getList()
    }
    const onSizeChange = (val) => {
        filters.page_size = val
        getList()
    }
    getList()


return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.name,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filters.name) = $event)),
        placeholder: "姓名",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_input, {
        class: "filter-item",
        modelValue: filters.user_phone,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((filters.user_phone) = $event)),
        placeholder: "手机号",
        style: {"width":"170px"},
        clearable: ""
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_select, {
        modelValue: filters.ilk,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((filters.ilk) = $event)),
        clearable: "",
        filterable: "",
        placeholder: "请选择类型",
        class: "filter-item",
        style: {"width":"150px"},
        onChange: _ctx.handleCatChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_option, {
            label: "公司",
            value: 1
          }),
          _createVNode(_component_el_option, {
            label: "个人",
            value: 2
          })
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.start_date,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filters.start_date) = $event)),
        placeholder: "提交开始时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _cache[9] || (_cache[9] = _createElementVNode("span", { class: "filter-item filter-divider" }, "-", -1)),
      _createVNode(_component_el_date_picker, {
        class: "filter-item",
        modelValue: filters.end_date,
        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((filters.end_date) = $event)),
        placeholder: "提交结束时间",
        "value-format": "YYYY-MM-DD"
      }, null, 8, ["modelValue"]),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[5] || (_cache[5] = ($event: any) => (search()))
      }, {
        default: _withCtx(() => _cache[7] || (_cache[7] = [
          _createTextVNode("搜索")
        ])),
        _: 1
      }),
      _createVNode(_component_el_button, {
        class: "filter-btn",
        type: "primary",
        onClick: _cache[6] || (_cache[6] = ($event: any) => (output()))
      }, {
        default: _withCtx(() => _cache[8] || (_cache[8] = [
          _createTextVNode("导出")
        ])),
        _: 1
      })
    ]),
    _createVNode(_component_el_table, {
      data: tableData.value,
      stripe: "",
      border: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_table_column, {
          type: "index",
          width: "60"
        }),
        _createVNode(_component_el_table_column, {
          prop: "user_name",
          label: "姓名",
          width: "90"
        }),
        _createVNode(_component_el_table_column, {
          prop: "user_phone",
          label: "电话",
          width: "130"
        }),
        _createVNode(_component_el_table_column, {
          prop: "user_compnay",
          label: "公司/个人",
          width: "200"
        }),
        _createVNode(_component_el_table_column, {
          prop: "notes",
          label: "留言"
        }, {
          default: _withCtx((scope) => [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", null, _toDisplayString(scope.row.notes), 1)
            ])
          ]),
          _: 1
        }),
        _createVNode(_component_el_table_column, {
          prop: "created_at",
          label: "提交时间",
          width: "160"
        })
      ]),
      _: 1
    }, 8, ["data"]),
    _createVNode(Pagination, {
      currentPage: filters.page,
      total: total.value,
      onPageChange: onPageChange,
      onSizeChange: onSizeChange
    }, null, 8, ["currentPage", "total"])
  ]))
}
}

})